import { FETCH_PRODUCTION_FACTORS } from '../actions';

export default (state = [], action) => {
	switch (action.type) {
		case FETCH_PRODUCTION_FACTORS:
			return action.payload;
		default:
			return state;
	}
};
